import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { EnterpriseOptionType } from '@app/core/interfaces/enterprise-option-type';
import { EnterpriseAuthorizationService } from '@app/shared/services/enterprise-authorization.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

/**
 * Structural directive `*portalHasEnterpriseOption="'P1'"` accepts an enterprise option as a string value.
 * If the enterprise has the option then the DOM element will be rendered.
 */
@UntilDestroy()
@Directive({
  selector: '[portalHasEnterpriseOption]',
  standalone: false,
})
export class HasEnterpriseOptionDirective implements OnInit {
  private _portalHasEnterpriseOption: EnterpriseOptionType[];

  @Input('portalHasEnterpriseOption')
  set portalHasEnterpriseOption(value: EnterpriseOptionType | EnterpriseOptionType[]) {
    this._portalHasEnterpriseOption = Array.isArray(value) ? value : [value];
  }

  @Input()
  portalHasEnterpriseOptionElse: TemplateRef<any>;

  @Input()
  portalHasEnterpriseOptionThen: TemplateRef<any>;

  constructor(
    private enterpriseAuthorizationService: EnterpriseAuthorizationService,
    private template: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this.enterpriseAuthorizationService
      .hasEnterpriseOptions$(this._portalHasEnterpriseOption)
      .pipe(untilDestroyed(this))
      .subscribe((hasEnterpriseOptions) => {
        // If not cleared it could happen that some elements are displayed multiple times
        this.viewContainer.clear();

        if (hasEnterpriseOptions) {
          if (this.portalHasEnterpriseOptionThen != null) {
            this.viewContainer.createEmbeddedView(this.portalHasEnterpriseOptionThen);
          } else {
            this.viewContainer.createEmbeddedView(this.template);
          }
        } else if (this.portalHasEnterpriseOptionElse != null) {
          this.viewContainer.createEmbeddedView(this.portalHasEnterpriseOptionElse);
        }
      });
  }
}
